const Community = () => {
    return (
        <> 
          <h1>COMMUNITY</h1> 
        </>
    );
};

export default Community;